import React from "react";

const ModalFooter = (props) => {
    return (
        <div className="modal-footer">
            {props.children}
        </div>
    )
}

export default ModalFooter;